import React from "react";

const FormShimmer = ({ rows = 4, cols = 2, shimmerActions = true }) => {
  return (
    <div className="form_shimmer">
      {[...Array(rows)].map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="shimmer_row"
          style={{
            gridTemplateColumns: `repeat(${cols}, 1fr)`,
          }}
        >
          {[...Array(cols)].map((_, colIndex) => (
            <div key={colIndex} className="shimmer_col">
              <div className="shimmer_label" />
              <div className={`shimmer_input`} />
            </div>
          ))}
        </div>
      ))}
      {shimmerActions && (
        <div className="shimmer_actions">
          <div className="shimmer_btn outline" />
          <div className="shimmer_btn primary" />
        </div>
      )}
    </div>
  );
};

export default FormShimmer;
